import { faCalendar } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'
import { useContext } from 'react'
import { DAYS } from '../../../constants/general'
import * as SETTINGS from '../../../constants/settings'
import { SiteConfigContext } from '../../../context/siteConfigContext'

const Schedule = () => {
  const { [SETTINGS.SCHEDULE.key]: schedule } = useContext(SiteConfigContext)

  if (Object.values(schedule).every((day) => day.length === 0)) {
    return null
  }
  return (
    <div className="hidden lg:grid lg:grid-cols-3 w-full lg:gap-2">
      <div className="col-span-3 w-full">
        <h3 className="border-b-2 border-brand-primary-500 w-fit pb-1">
          <FontAwesomeIcon icon={faCalendar} className="mr-3 h-6" />
          Schedule
        </h3>
      </div>
      <div className="col-span-3 w-full">
        <ul className="flex justify-between border border-neutral-200 rounded-xl shadow-md bg-white dark:bg-black dark:border-neutral-900 divide-x divide-neutral-200 dark:divide-neutral-900">
          {DAYS.map((day) => {
            return (
              schedule[day].length > 0 && (
                <DayAndTimes key={day} day={day} times={schedule[day]} />
              )
            )
          })}
        </ul>
      </div>
    </div>
  )
}

const DayAndTimes = ({ day, times }) => {
  return (
    <li className="flex flex-col justify-start p-4 w-full">
      <p className="font-medium capitalize">{day}</p>
      {times.length >= 1 &&
        times.map((times, index) => {
          return <p key={index}>{times}</p>
        }, this)}
    </li>
  )
}

DayAndTimes.propTypes = {
  day: PropTypes.string.isRequired,
  times: PropTypes.array.isRequired
}

export default Schedule
